<template>
<div id="tablePrint" class="w-100">
    <b-table
        show-empty
        responsive
        empty-text="ไม่มีรายละเอียดข้อมูลยอดขาย"
        empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
        class="scroll-bar-pop text-center table-sticky"
        :sort-desc="true"
        :items="order.data"
        :fields="fields"
    >
        <template slot="index" slot-scope="data">
            {{(order.current_page - 1) * order.per_page + data.index + 1}}
        </template>
        <template slot="status" slot-scope="row">
            <b-badge :variant="statusInfo(row.item).color" >
                {{statusInfo(row.item).status}}
            </b-badge>
        </template>
    </b-table>
    <div class="mt-3">
        <b-pagination
            :total-rows="order.total_item"
            :per-page="order.per_page"
            @input="changePage"
            align="right"
        ></b-pagination>
    </div>
</div>
</template>
<script>
import columns from './js/columns'
import { statusInfo } from "@/plugins/statusCourier.js"
export default {
    name: 'Table',
    props:{
        order:{
            type: Object,
            default: {
                data: [],
                current_page: 1,
                total_item: 0,
                per_page: 0
            }
        },
        onChangePage: Function
    },
    data(){
        return{
            statusInfo: statusInfo
        }
    },
    methods:{
        async changePage( page ){
            if( this.order.current_page == page || !page ) return false
            this.order.current_page = page
            const data = await this.onChangePage()
            this.setOrder(data.data)
        },
        setOrder( results ){
            this.order.current_page = results.current_page
            this.order.per_page = results.per_page
            this.order.total_item = results.total_item
            this.order.data = results.data
        },
    },
    computed:{
        fields(){
            if( this.$USER_LOGIN.get().isShippop || this.$USER_LOGIN.get().isSuperadmin )
            return columns
            else return columns.filter( col => col.key !== 'shop_name' )
        }
    }
}
</script>